import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import * as req from 'src/app/entities/request';
import { LocalService, Status } from 'src/service/local.service';
import { PrinterService } from 'src/service/printer.service';

@Component({
  selector: 'app-printer-device-popup',
  templateUrl: './printer-device-popup.component.html',
  styleUrl: './printer-device-popup.component.scss'
})
export class PrinterDevicePopupComponent {
  @ViewChild('content_receipt_device') content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  @Input() itemId: string | undefined = undefined;
  @Input() businessId: string;
  @Input() ctryCode: string;

  title: string = '';
  deviceId: string = '';

  htmlId: string = '';
  elementIds: any;

  message: string = ''; isRedAlert: boolean = true;

  constructor(public localService: LocalService, private offcanvasService: NgbOffcanvas, private printerService: PrinterService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      save_printer_device: 'save-printer-device-' + this.htmlId
    };
  }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onLoad() {
    if (this.itemId) {
      const req = { BusinessId: this.businessId, CountryCode: this.localService.getLoginAsCountryCode() } as req.BusinessDetail;
      this.printerService.getPrinterDevice(req, this.itemId).subscribe(result => {
        if (result.Mandatory.Status && result.Mandatory.Status == Status.Success) {
          this.title = result.Title;
          this.deviceId = result.DeviceId
        }
      });
    } else {
      this.title = '';
    }
  }

  onAction(index: number) {
    switch (index) {
      case 1: {
        if (this.onDoCheck()) {
          const req = { BusinessId: this.businessId, CountryCode: this.localService.getLoginAsCountryCode(), Key: this.itemId, Title: this.title.trim(), DeviceId: this.deviceId } as req.PrinterDevice;
          this.printerService.savePrinterDevice(req).subscribe(result => {
            this.localService.showInformationByStatus(result.status);
            if (result.status == Status.Success) {
              this.onCloseTrigger();
            }
          });
        }
      } break;
    }
  }
  onDoCheck(): boolean {
    let isPassed = true;
    let message = '';
    if (!this.title.trim()) {
      message = this.localService.languageContent.printer.titleRequired;
      isPassed = false;
    } else if (!this.deviceId.trim()) {
      message = this.localService.languageContent.printer.deviceRequired;
      isPassed = false;
    }

    this.message = message;
    return isPassed;
  }
}
